import clsx from 'clsx';
import React from 'react';

import TopicPill from '@components/Topic/TopicFollowAndTagModal/TopicPill';

import type { SearchPageProps } from './index';

type SearchHeaderProps = Pick<SearchPageProps, 'title' | 'topRelatedEntities'>;

const SearchHeader = ({ title, topRelatedEntities }: SearchHeaderProps) => {
  return (
    <div className="mb-12 mt-24">
      <div className="mb-24 mt-8 font-serif text-headline-sm font-bold text-grayscale-50">
        Search results for: &ldquo;{title}&rdquo;
      </div>
      <div className="border-0 border-y border-solid border-neutral-300 py-8 text-overline uppercase">
        Related Topics
      </div>
      <div className="mt-12 flex items-center gap-4">
        {topRelatedEntities.map(({ matchingEntity, name }) => (
          <TopicPill
            className={clsx({
              '!bg-primary-red !text-white hover:!bg-red-400': matchingEntity,
            })}
            key={name}
            topic={name}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchHeader;
